import { useState, useEffect, useRef } from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
import SliderMain from "./SliderMain";
import PreorderService from "api/precision/PreorderService";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Preview from "./Preview";
import ImageCropper from "common/ImageCropper";
import CAPTCHA from "react-google-recaptcha";
import { Link } from "react-scroll";
import html2canvas from 'html2canvas';

// import BoxSleeveMail from "../see/BoxSleeveMail";
// https://reactjsexample.com/a-simple-captcha-image-generator-for-react/
// Captchs admin console - https://www.google.com/recaptcha/admin/site/680612767
// import { confirmAlert } from 'react-confirm-alert';
// import 'react-confirm-alert/src/react-confirm-alert.css';
// import 'react-phone-number-input/style.css';


const BoxSleeve = ({
  adors,
  session,
  products,
  cartItems,
  setActiveProduct,
  addTocart,
}) => {

  // Blob - Image after upload
  const [imageToCrop, setImageToCrop] = useState(undefined);
  // base64 - Image after cropped
  const [croppedImage, setCroppedImage] = useState(undefined);
  // Current editing item
  const [curProduct, setCurProduct] = useState({ id: session.pid });
  const [warning, setWarning] = useState(false);
  const [custCompleted, setCustCompleted] = useState(false);
  //
  const captchaRef = useRef(null);

  // Error array
  const errorsObj = {
    image_upload: false,
    quantity: false,
    customer_type: false,
    email: false,
    contact_name: false,
    phone: false,
    street: false,
    city: false,
    state: false,
    zip_code: false,
    candy_assortment: false,
  };
  const [errors, setErrors] = useState(errorsObj);

  // Boxsize - to pass to preview
  const [curBoxSize, setCurBoxSize] = useState({
    product_id: "99x44",
    box_size: ""
  });

  // Set current customizable product
  useEffect(() => {
    // console.log('Sending document height...', document.body.getBoundingClientRect().height);
    window.parent.postMessage(
      {
        sid: session.sid,
        action: "ready",
        documentHeight: document.body.getBoundingClientRect().height,
      },
      "*"
    );
  });

  // Set current customizable product
  useEffect(() => {
    let current = null;
    if (cartItems && cartItems.length > 0) {
      current = cartItems.find((element) => element.id == session.pid);
    } else {
      const prod = products.find((product) => product.id === session.pid);
      current = {
        id: session.pid,
        name: prod.name,
        message: "",
        min_quantity: 50,
        max_quantity: prod ? prod.max_quantity : 1,
        quantity: 50,
        Photo: null,
        contact_name: "",
        company_name: "",
        customer_type: "",
        email: "",
        phone: "",
        street: "",
        city: "",
        state: "",
        zip_code: "",
        wrapping_paper: "",
        flavor: "",
        candy_assortment: "",
      };
    }
    // console.log(current);
    setCurProduct(current);
    // debugger;
    // console.log(process.env.REACT_APP_SITE_KEY);

  }, [session.pid]);

  const changeProduct = (productId) => {
    if (session.pid != productId) {
      setActiveProduct(productId);
    }
  };

  const onUploadFile = (event) => {
    setWarning(false);
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      const img = new Image();
      img.src = URL.createObjectURL(file);
      img.onload = () => {
        // debugger;
        const widthInInches = img.naturalWidth / 200;
        const heightInInches = img.naturalHeight / 200;
        if (widthInInches < 6 || heightInInches < 3) {
          setWarning(true);
        }
        const reader = new FileReader();
        reader.onload = (e) => {
          setImageToCrop(e.target.result);
        };
        reader.readAsDataURL(file);
      };
    }
  };

  const onCropImage = ({ blob }) => {
    var reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      var base64String = reader.result;
      setCroppedImage(base64String);
      console.log(croppedImage);
    };
  };

  const handleChange = (ev) => {
    ev.stopPropagation();

    const name = ev.target.name;
    const value = ev.target.value.trim();
    let ok = true;
    if (name == "quantity") {
      if (value < 50) {
        setErrors({ ...errors, [name]: true });
        ok = false;
        ev.target.setAttribute("aria-invalid", "true");
      } else {
        setErrors({ ...errors, [name]: false });
        ev.target.setAttribute("aria-invalid", "false");
      }
    } else {
      if (ev.target.required && value == "") {
        setErrors({ ...errors, [name]: true });
        ok = false;
        ev.target.setAttribute("aria-invalid", "true");
      } else {
        setErrors({ ...errors, [name]: false });
        ev.target.setAttribute("aria-invalid", "false");
      }
    }

    setCurProduct({ ...curProduct, [name]: ev.target.value });
    setCustCompleted(ok);

    // Change image and boxsize
    if (name == "candy_assortment") {
      if (value.startsWith("9.9 x 4.4 inches")) {
        setCurBoxSize({ product_id: "99x44", box_size: "9.9 x 4.4 inches" });
      }
      else if (value.startsWith("9.7 X 5.7 inches")) {
        setCurBoxSize({ product_id: "97x57", box_size: "9.7 X 5.7 inches" });
      }
      else if (value.startsWith("5.5 x 3.5 inches")) {
        setCurBoxSize({ product_id: "55x35", box_size: "5.5 x 3.5 inches" });
      }
    }

    // Tell the server to get score
    window.parent.postMessage(
      {
        sid: session.sid,
        action: "change",
      },
      "*"
    );
  };

  // Return true if customer info is valid, if tabNum = 2 include candy_assortment
  const validateForm = (skipField) => {
    let ok = true;

    for (let key in errorsObj) {
      const el = document.getElementById(key);
      if (key == "quantity") {
        if (el.value < 50) {
          errors[key] = true;
          setErrors({ ...errors, [key]: true });
          ok = ok && false;
          el.setAttribute("aria-invalid", "true");
        } else {
          errors[key] = false;
          setErrors({ ...errors, [key]: false });
          el.setAttribute("aria-invalid", "false");
        }
      } else if (skipField && key == skipField) {
      } else {
        if (!el.checkValidity()) {
          errors[key] = true;
          setErrors({ ...errors, [key]: true });
          ok = ok && false;
          el.setAttribute("aria-invalid", "true");
        } else {
          errors[key] = false;
          setErrors({ ...errors, [key]: false });
          el.setAttribute("aria-invalid", "false");
        }
      }
    }
    return ok;
  };

  //#region Delete
  /*
    const [idToDelete, setIdToDelete] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const handleCloseModal = () => {
      setShowModal(false);
    };
    const ModalMail = (id) => {
      setShowModal(true);
    
    };

  // This is not working
  const convertHtmlToImage = (elementId) => {
    return new Promise((resolve, reject) => {
      const tableElement = document.getElementById(elementId); 
      html2canvas(tableElement)
        .then((canvas) => {
          resolve(canvas.toDataURL("image/jpeg"));
        })
        .catch((error) => {
          reject(error);
        });
    });
  };
  */
  //#endregion


  const handleSubmit = (ev) => {
    ev.stopPropagation();
    ev.preventDefault();

    if (validateForm()) {
      const captcha_token = captchaRef.current.getValue();
      // console.log(captcha_token);
      if (!captcha_token) {
        return false;
      }
      const data = {
        captcha_token: captcha_token,
        customer_id: 2177,
        user_id: 217286,
        session_id: session.sid,
        quantity: curProduct.quantity,
        adors: {
          Photo: croppedImage,
        },
        output_type: "JOB_INFO",
        confirmation_email: 1,
        image_content: getPreviewImage(),
        customs: {
          // "message": curProduct.message,
          contact_name: curProduct.contact_name,
          company_name: curProduct.company_name,
          customer_type: curProduct.customer_type,
          email: curProduct.email,
          phone: curProduct.phone,
          street: curProduct.street,
          city: curProduct.city,
          state: curProduct.state,
          zip_code: curProduct.zip_code,
          wrapping_paper: curProduct.wrapping_paper,
          candy_assortment: curProduct.candy_assortment,
        },
      };
      PreorderService.add(data)
        .then((res) => {
          if (res.data.result == 1) {
            // Call parent to close iframe
            let msg = {
              sid: session.sid,
              action: "close",
              customer_info: data["customs"],
              photo: croppedImage,
            };
            // window.parent.postMessage(msg, "https://volume-savings.sees.com");
            window.parent.postMessage(msg, "*");
          } else {
            console.error(res.data.data);
          }
          captchaRef.current.reset();
        })
        .catch((error) => {
          console.error("Error fetching product data:", error);
        });
    }
    return false;
  };

  const previewSettings = {
    // Preview windows on resize redraw
    responsive: [
      {
        breakPoint: 1400,
      },
      {
        breakPoint: 1200,
      },
      {
        breakPoint: 1000,
      },
      {
        breakPoint: 800,
      },
      {
        breakPoint: 400,
      },
    ],
  };

  const todayDate = () => {
    let dt = new Date();
    return dt.toLocaleDateString();
  };

  const getPreviewImage = () => {
    const canvas = document.getElementById('my-canvas');
    return canvas && canvas.toDataURL("image/jpeg");
  }

  return (
    <>
      <Container className="py-1 is-screen">
        <Form>

          <div className="customize-box-steps d-flex flex-column flex-md-row justify-content-md-center align-items-start align-items-md-center mt-3 mb-4">
            <div className="cb-step-1 d-flex gap-3 justify-content-center align-items-center">
              <Link
                to="customizeBox"
                smooth={true}
                offset={-20}
                duration={400}
                className="d-flex gap-4 justify-content-center align-items-center step-num"
              >
                1
              </Link>

              <div className="step-title">
                <Link
                  to="customizeBox"
                  smooth={true}
                  offset={-20}
                  duration={400}
                  className="text-decoration-none"
                >
                  Customize
                </Link>
              </div>
            </div>
            <div className="cb-step-1 d-flex gap-3 justify-content-center align-items-center">
              <Link
                to="selectCandy"
                smooth={true}
                offset={-20}
                duration={750}
                className={`d-flex gap-4 justify-content-center align-items-center step-num ${custCompleted ? '' : 'inactive'}`}
              >
                2
              </Link>

              <div className="step-title">
                <Link
                  to="selectCandy"
                  smooth={true}
                  offset={-20}
                  duration={750}
                  className="text-decoration-none"
                >
                  Select Candy / Wrap
                </Link>
              </div>
            </div>
            <div className="cb-step-1 d-flex gap-3 justify-content-center align-items-center">
              <Link
                to="selectCandySubmit"
                smooth={true}
                offset={-20}
                duration={750}
                className={`d-flex gap-4 justify-content-center align-items-center step-num inactive`}
              >
                3
              </Link>
              <div className="step-title">
                <Link
                  to="selectCandySubmit"
                  smooth={true}
                  offset={-20}
                  duration={750}
                  className="text-decoration-none"
                >
                  Submit
                </Link>
              </div>
            </div>
          </div>

          <div id="customizeBox" className="see-form pt-lg-4">
            <h2 className="mb-3 text-center">Customize Your Box Sleeve</h2>
            {/*
                <div className="row">
                  <div className="col">
                    <SliderMain session={session} products={products} changeProduct={changeProduct} />
                  </div>
                </div>
              */}

            <div className="row">
              <div className="col">
                <Preview
                  adors={adors}
                  curBoxSize={curBoxSize}
                  croppedImage={croppedImage}
                  previewSettings={previewSettings}
                />
              </div>
            </div>

            <Row className="pt-1 pb-1">
              <Col md={5}>
                <label for="image-upload">Upload Photo</label>
                <br />
                <span className="text-muted fs-7">
                  <b>(Jpeg or PNG)</b> <br />* We recommend saving artwork
                  in landscape (horizontal) format for best results.
                </span>
              </Col>
              <Col md={7}>
                <Form.Control
                  id="image_upload"
                  className="form-control"
                  type="file"
                  accept="image/*"
                  onChange={onUploadFile}
                  required
                  aria-errormessage="err_image_upload"
                />
                {warning && (
                  <div
                    id="warning_image_upload"
                    className="text-danger fs-7 mt-1"
                  >
                    {" "}
                    Warning : Higher resolution image is recommended.

                  </div>
                )}
                {errors.image_upload && (
                  <div className="fs-7 text-danger" id="err_image_upload">
                    <i className="fa fa-times-circle m-2"> </i> Image upload
                    is required.
                  </div>
                )}
                <div>
                  <ImageCropper
                    imageToCrop={imageToCrop}
                    onImageCropped={onCropImage}
                  />
                </div>
              </Col>
            </Row>


            <h2 className="my-3 text-start"
              style={{ fontSize: "1.2rem" }}
              id={"selectCandy"}
            >
              Select Candy & Wrapping Paper
            </h2>
            <Row className="pt-3 pb-3">
              <Col md={5}>
                <label
                  className={
                    errors.candy_assortment === true ? "text-danger" : ""
                  }
                  for="candy_assortment"
                >
                  Candy Assortment*
                </label>

              </Col>
              <Col md={7}>
                <Form.Select
                  id="candy_assortment"
                  name="candy_assortment"
                  value={curProduct && curProduct.candy_assortment}
                  onChange={handleChange}
                  className="rounded-0"
                  required
                  aria-errormessage="err_candy_assortment"
                >
                  <option value=""> </option>
                  <optgroup label="9.9 x 4.4 inches">
                    <option value="9.9 x 4.4 inches 1lb_Ast">
                      1lb Assorted Chocolates (9.9 x 4.4 inches) - $36.00
                    </option>
                    <option value="9.9 x 4.4 inches 2lb_Ast">
                      2lb Assorted Chocolates (9.9 x 4.4 inches) - $66.00
                    </option>
                    <option value="9.9 x 4.4 inches 1lb_Mlk">
                      1lb Milk Chocolates (9.9 x 4.4 inches) - $36.00
                    </option>
                    <option value="9.9 x 4.4 inches 1lb_Drk">
                      1lb Dark Chocolates (9.9 x 4.4 inches) - $36.00
                    </option>
                    <option value="9.9 x 4.4 inches 1lb_Soft">
                      1lb Soft Centers (9.9 x 4.4 inches) - $36.00
                    </option>
                    <option value="9.9 x 4.4 inches 1lb_C&V">
                      1lb Chocolate & Variety (9.9 x 4.4 inches) - $36.00
                    </option>
                  </optgroup>
                  <optgroup label="9.7 X 5.7 inches">
                    <option value="9.7 X 5.7 inches 1lb_N&C">
                      1lb Nuts & Chews (9.7 X 5.7 inches) - $36.00
                    </option>
                    <option value="9.7 X 5.7 inches 2lb_N&C">
                      2lb Nuts & Chews (9.7 X 5.7 inches) - $66.00
                    </option>
                    <option value="9.7 X 5.7 inches 1_5oz_Ast_Lolly">
                      1lb 5oz Assorted Lollypops (9.7 X 5.7 inches) - $37.50
                    </option>
                    <option value="9.7 X 5.7 inches 1_5_PB">
                      1lb 5oz Peanut Brittle (9.7 X 5.7 inches) - $36.00
                    </option>
                  </optgroup>

                  <optgroup label="5.5 x 3.5 Inches">
                    <option value="5.5 x 3.5 inches 8oz_Silver_Ast">
                      8oz Silver Assorted (5.5 x 3.5 inches) - $21.75
                    </option>
                    <option value="5.5 x 3.5 inches 8oz_Gold_Truf">
                      8oz Gold Truffles (5.5 x 3.5 inches) - $21.75
                    </option>
                  </optgroup>

                </Form.Select>
                {errors.candy_assortment && (
                  <div
                    className="fs-7 text-danger"
                    id="err_candy_assortment"
                  >
                    <i className="fa fa-times-circle m-2"> </i> Candy
                    assortment is required
                  </div>
                )}
              </Col>
            </Row>

            <Row className="pt-3 pb-3">
              <Col md={5}>
                <label for="wrapping_paper">Wrapping Paper</label>
              </Col>
              <Col md={7}>
                <Form.Select
                  id="wrapping_paper"
                  name="wrapping_paper"
                  value={curProduct && curProduct.wrapping_paper}
                  onChange={handleChange}
                  className="rounded-0"
                >
                  <option value=""> </option>
                  <option value="White"> White </option>
                  <option value="Seasonal"> Seasonal </option>
                </Form.Select>
              </Col>
            </Row>


            <Row className="pt-3 pb-3">
              <Col md={5}>
                <label for="quantity">Quantity</label>
                <br />
                <span className="text-muted fs-7">
                  (Minimum order of {50}{" "}
                  units applies)
                </span>
              </Col>
              <Col md={7}>
                <Form.Control
                  id="quantity"
                  name="quantity"
                  value={curProduct && curProduct.quantity}
                  onChange={handleChange}
                  type="number"
                  min={50}
                  max={curProduct && curProduct.max_quantity}
                  className="form-control"
                  required
                  aria-errormessage="err_quantity"
                />
                {errors.quantity && (
                  <div className="fs-7 text-danger" id="err_quantity">
                    <i className="fa fa-times-circle m-2"> </i>
                    Quantity must be greater than {50}
                  </div>
                )}
              </Col>
            </Row>
            {/* 
                <Row className="pt-3 pb-3">
                  <Col md={5}>
                    <label for="message">Message on Logo Box (optional)</label><br />
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      value={curProduct && curProduct.message}
                      onChange={handleChange}
                      name="message"
                      id="message"
                      as="textarea"
                      rows={3}
                      className="rounded-0"
                    />
                  </Col>
                </Row>
            */}

            <div className="step-tabs">
              <h2 className="my-3 text-start" style={{ fontSize: "1.2rem" }}>
                Enter Customer Information
              </h2>

              <Row className="pt-3 pb-3">
                <Col md={5}>
                  <label for="company_name">Company</label>
                </Col>
                <Col md={7}>
                  <Form.Control
                    id="company_name"
                    name="company_name"
                    value={curProduct && curProduct.company_name}
                    onChange={handleChange}
                    type="text"
                    placeholder="Company Name"
                    className="rounded-0"
                  />
                </Col>
              </Row>

              <Row className="pt-3 pb-3">
                <Col md={5}>
                  <label
                    className={
                      errors.customer_type === true ? "text-danger" : ""
                    }
                    for="customer_type"
                  >
                    Customer*
                  </label>
                  <br />
                </Col>
                <Col md={7}>
                  <Form.Select
                    id="customer_type"
                    name="customer_type"
                    value={curProduct && curProduct.customer_type}
                    onChange={handleChange}
                    className="rounded-0"
                    required
                    aria-errormessage="err_customer_type"
                  >
                    <option value=""> </option>
                    <option value="New"> New </option>
                    <option value="Returning"> Returning </option>
                  </Form.Select>
                  {errors.customer_type && (
                    <div
                      className="fs-7 text-danger"
                      id="err_customer_type"
                    >
                      <i className="fa fa-times-circle m-2"> </i>
                      Customer is required
                    </div>
                  )}
                </Col>
              </Row>

              <Row className="pt-3 pb-3">
                <Col md={5}>
                  <label
                    className={
                      errors.contact_name === true ? "text-danger" : ""
                    }
                    for="contact_name"
                  >
                    Contact Name*
                  </label>
                </Col>
                <Col md={7}>
                  <Form.Control
                    id="contact_name"
                    name="contact_name"
                    value={curProduct && curProduct.contact_name}
                    onChange={handleChange}
                    type="text"
                    placeholder="Full Name"
                    className="rounded-0"
                    required
                    aria-errormessage="err_contact_name"
                  />
                  {errors.contact_name && (
                    <div className="fs-7 text-danger" id="err_contact_name">
                      <i className="fa fa-times-circle m-2"> </i>
                      Contact name is required
                    </div>
                  )}
                </Col>
              </Row>

              <Row className="pt-3 pb-3">
                <Col md={5}>
                  <label
                    className={errors.email === true ? "text-danger" : ""}
                    for="email"
                  >
                    Email*
                  </label>
                </Col>
                <Col md={7}>
                  <Form.Control
                    id="email"
                    name="email"
                    value={curProduct && curProduct.email}
                    onChange={handleChange}
                    type="email"
                    pattern=".+@.+\..+"
                    placeholder="Email"
                    className="rounded-0"
                    required
                    aria-errormessage="err_email"
                  />
                  {errors.email && (
                    <div className="fs-7 text-danger" id="err_email">
                      <i className="fa fa-times-circle m-2"> </i> Email is
                      invalid
                    </div>
                  )}
                </Col>
              </Row>

              <Row className="pt-3 pb-3">
                <Col md={5}>
                  <label
                    className={errors.phone === true ? "text-danger" : ""}
                    for="phone"
                  >
                    Phone*
                  </label>
                </Col>
                <Col md={7}>
                  <Form.Control
                    id="phone"
                    name="phone"
                    value={curProduct && curProduct.phone}
                    onChange={handleChange}
                    type="tel"
                    placeholder="Phone"
                    className="rounded-0"
                    required
                    aria-errormessage="err_phone"
                  />
                  {errors.phone && (
                    <div className="fs-7 text-danger" id="err_phone">
                      <i className="fa fa-times-circle m-2"> </i> Phone number is required
                    </div>
                  )}
                </Col>
              </Row>

              <Row className="pt-3 pb-3">
                <Col md={5}>
                  <label
                    className={errors.street === true ? "text-danger" : ""}
                    for="street"
                  >
                    Shipping address*
                  </label>
                </Col>
                <Col md={7}>
                  <Form.Control
                    id="street"
                    name="street"
                    value={curProduct && curProduct.street}
                    onChange={handleChange}
                    type="text"
                    placeholder="Street address"
                    className="rounded-0"
                    required
                    aria-errormessage="err_street"
                  />
                  {errors.street && (
                    <div className="fs-7 text-danger" id="err_street">
                      <i className="fa fa-times-circle m-2"> </i> Street
                      address is required
                    </div>
                  )}
                </Col>
              </Row>

              <Row className="pt-3 pb-3">
                <Col md={5}>
                  <label
                    className={errors.city === true ? "text-danger" : ""}
                    for="city"
                  >
                    City*
                  </label>
                </Col>
                <Col md={7}>
                  <Form.Control
                    id="city"
                    name="city"
                    value={curProduct && curProduct.city}
                    onChange={handleChange}
                    type="text"
                    placeholder="City"
                    className="rounded-0"
                    required
                    aria-errormessage="err_city"
                  />
                  {errors.city && (
                    <div className="fs-7 text-danger" id="err_city">
                      <i className="fa fa-times-circle m-2"> </i> City is required </div>
                  )}
                </Col>
              </Row>

              <Row className="pt-3 pb-3">
                <Col md={5}>
                  <label
                    className={errors.state === true ? "text-danger" : ""}
                    for="state"
                  >
                    State*
                  </label>
                </Col>
                <Col md={7}>
                  <Form.Control
                    id="state"
                    name="state"
                    value={curProduct && curProduct.state}
                    onChange={handleChange}
                    type="text"
                    placeholder="State"
                    className="rounded-0"
                    required
                    aria-errormessage="err_state"
                  />
                  {errors.state && (
                    <div className="fs-7 text-danger" id="err_state">
                      <i className="fa fa-times-circle m-2"> </i> State is
                      required
                    </div>
                  )}
                </Col>
              </Row>

              <Row className="pt-3 pb-3">
                <Col md={5}>
                  <label
                    className={
                      errors.zip_code === true ? "text-danger" : ""
                    }
                    for="zip_code"
                  >
                    Postal code*
                  </label>


                </Col>
                <Col md={7}>
                  <Form.Control
                    id="zip_code"
                    name="zip_code"
                    value={curProduct && curProduct.zip_code}
                    onChange={handleChange}
                    type="text"
                    placeholder="Postal code"
                    className="rounded-0"
                    required
                    aria-errormessage="err_zip_code"
                  />

                  {errors.zip_code && (
                    <div className="fs-7 text-danger" id="err_zip_code">
                      <i className="fa fa-times-circle m-2"> </i> Postal
                      code is required
                    </div>
                  )}
                  <div className="fs-7 text-danger p-1" id="err_zip_code">Please allow a 4-weeks lead time.</div>
                </Col>
              </Row>

              { /*
              <h2 className="my-3 text-start"
                style={{ fontSize: "1.2rem" }}
                id={"selectCandy"}
              >
                Select Candy & Wrapping Paper
              </h2>
              <Row className="pt-3 pb-3">
                <Col md={5}>
                  <label
                    className={
                      errors.candy_assortment === true ? "text-danger" : ""
                    }
                    for="candy_assortment"
                  >
                    Candy Assortment*
                  </label>

                </Col>
                <Col md={7}>
                  <Form.Select
                    id="candy_assortment"
                    name="candy_assortment"
                    value={curProduct && curProduct.candy_assortment}
                    onChange={handleChange}
                    className="rounded-0"
                    required
                    aria-errormessage="err_candy_assortment"
                  >
                    <option value=""> </option>
                    <option value="1lb_assorted_chocolates">
                      1lb Assorted Chocolates
                    </option>
                    <option value="2lb_Assorted_chocolates">
                      2lb Assorted Chocolates
                    </option>
                    <option value="1lb_nuts_and_chews">
                      1lb Nuts & Chews
                    </option>
                    <option value="2lb_nuts_and_chews">
                      2lb Nuts & Chews
                    </option>
                    <option value="1lb_milk_chocolates">
                      1lb Milk Chocolates
                    </option>
                    <option value="1lb_dark_chocolates">
                      1lb Dark Chocolates
                    </option>
                    <option value="1lb_soft_centers">
                      1lb Soft Centers
                    </option>
                    <option value="1lb_chocolate_and_variety">
                      1lb Chocolate & Variety
                    </option>
                    <option value="1lb5oz_assorted_lollypops">
                      1lb5oz Assorted Lollypops
                    </option>
                    <option value="1.5lb_peanut_brittle">
                      1.5lb Peanut Brittle
                    </option>
                    <option value="8oz_silver_assorted">
                      8oz Silver Assorted
                    </option>
                    <option value="8oz_gold_truffles">
                      8oz Gold Truffles
                    </option>
                  </Form.Select>
                  {errors.candy_assortment && (
                    <div
                      className="fs-7 text-danger"
                      id="err_candy_assortment"
                    >
                      <i className="fa fa-times-circle m-2"> </i> Candy
                      assortment is required
                    </div>
                  )}
                </Col>
              </Row>

              <Row className="pt-3 pb-3">
                <Col md={5}>
                  <label for="wrapping_paper">Wrapping Paper</label>
                </Col>
                <Col md={7}>
                  <Form.Select
                    id="wrapping_paper"
                    name="wrapping_paper"
                    value={curProduct && curProduct.wrapping_paper}
                    onChange={handleChange}
                    className="rounded-0"
                  >
                    <option value=""> </option>
                    <option value="White"> White </option>
                    <option value="Seasonal"> Seasonal </option>
                  </Form.Select>
                </Col>
              </Row>
              */ }


              <Row className="pt-3">
                <Col md={5}>
                  <p className="my-1"> </p>
                </Col>
                <Col md={7}>

                  <CAPTCHA
                    ref={captchaRef}
                    sitekey={process.env.REACT_APP_SITE_KEY}
                  />

                  <div
                    id="selectCandySubmit"
                    className="text-center mt-4 d-flex gap-4 justify-content-center align-items-center"
                  >
                    <button
                      className="btn bg-black text-white rounded-0 ms-auto"
                      id="submit_btn"
                      name="submit_btn"
                      type="submit"
                      onClick={handleSubmit}
                    >
                      Submit Inquiry
                    </button>
                  </div>
                </Col>
              </Row>
            </div>
          </div>

        </Form>
      </Container>


    </>
  );
};

export default BoxSleeve;
